module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"keys":{"api-data":"Dados da API"}},"en-US":{"keys":{"api-data":"API Data"}}}')
  delete Component.options._Ctor
}
